<template>
  <div style="background-color: #fff;">
    <EducationHeader />
    <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <img class="bannerImg" src="@/assets/img/kjrc-cyds.jpg" />
        </div>
      </a-carousel>
    </div>
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <FilterInfo :list="getFilterInfo" @changeValue="getFilterSearch($event)" />
    <div class="listBigBox">
      <div class="industrialBox">
        <!-- <div class="industrialTitleBox">
          <div class="industrialTitle">
            创业导师
          </div>
        </div> -->
        <div class="industrialContentBox">
          <div class="talentSmallBox" v-for="(item, index) in dataSource" :key="index" @click="goDetail(item.userId)">
            <div class="teacherLeftBox">
              <img v-if="item.userLogo" :src="getImg(item.userLogo)" alt="">
              <img v-else src="@/assets/img/userPhoto.jpg" alt="">
            </div>
            <div class="teacherRightBox">
              <div class="teacherName">
                {{ item.name }}&nbsp; / &nbsp;<dict-render :dict-obj="dictObjs['education_background']"
                  v-if="item.educationBackground" :text="item.educationBackground"></dict-render>
              </div>
              <div class="teacherInfo">
                <div style="margin: 10px 0 5px 0;">职称：<dict-render :dict-obj="dictObjs['professionalTitle']"
                    v-if="item.professionalTitle" :text="item.professionalTitle"></dict-render></div>
                <div class="teacherResearch">研究领域：<dict-render :dict-obj="dictObjs['research_field']"
                    v-if="item.researchArea" :text="item.researchArea"></dict-render></div>
              </div>
            </div>
          </div>
        </div>
        <!--分页-->
        <div class="pagination">
          <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
        </div>
      </div>
    </div>
      <layout-footer/>
  </div>
</template>
<script>
import { getDistMixin, listMixin, dictMixin } from "@/mixins";
import FilterInfo from '@/components/other/FilterInfo';
import EducationHeader from './educationHeader';
import { entrepreneurshipMentor } from '@/api/educationService';
import DictRender from "@/components/other/DictRender";
import { file_service } from "@/api/adminService";
import LayoutFooter from "@/layout/layoutPage/footer/LayoutFooterNew2.vue";

export default {
  name: 'innovationBigData',
  mixins: [getDistMixin, listMixin, dictMixin],
  components: {LayoutFooter, FilterInfo, DictRender, EducationHeader },
  data() {
    return {
      dictNames: 'education_background,professionalTitle,research_field',
      queryParam: { professionalTitle: '' },
      listUrl: entrepreneurshipMentor.pageList,
      current: 1,
      total: 12,
      pageSize: 12,
      filterInfo: {},
      searchData: '',
      title: '',
    }
  },
  created() {
    this.getDist('professionalTitle')
    this.getDist('research_field')
    this.title = this.$route.query.type
  },
  computed: {
    getFilterInfo() {
      let list = []
      let obj = {}
      let obj1 = {}
      let obj2 = {}
      let obj3 = {}
      obj1['职称类型'] = this.professionalTitleArr
      obj['search'] = 'professionalTitle'
      obj2['arr'] = obj1
      obj3 = Object.assign(obj, obj2)
      list.push(obj3)


      let type = {}
      let type1 = {}
      let type2 = {}
      let type3 = {}
      type1['研究领域'] = this.industryArr
      type['search'] = 'researchArea'
      type2['arr'] = type1
      type3 = Object.assign(type, type2)
      list.push(type3)
      return list
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: '/educationService/components/entrepreneurshipMentorDetail',
        query: { type: '创业导师', id: id }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
  }
}
</script>
<style scoped lang="less">
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.listBigBox {
  width: 1200px;
  margin: 10px auto;

  .industrialBox {
    width: 1200px;
    margin: 20px auto;

    .industrialTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      margin-bottom: 10px;
      border-bottom: 1px solid #dedede;

      .industrialTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .industrialTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #035aea;
      }

      .MoreBox {
        float: right;
        color: #999;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .industrialContentBox {
      padding: 14px 10px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;

      .talentSmallBox {
        width: 23%;
        position: relative;
        padding: 10px 5px;
        margin: 0 12px 15px 12px;
        border: 1px solid #dedede;
        cursor: pointer;

        .teacherLeftBox {
          float: left;
          width: 80px;
          height: 80px;
          padding: 10px;
          display: flex;
          justify-content: center;
          align-items: center;


          img {
            overflow: hidden;
            border-radius: 50%;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .teacherRightBox {
          float: left;
          width: 50%;
          margin-left: 10px;
          padding-top: 10px;

          .teacherName {
            font-size: 16px;
            color: #333;
          }

          .teacherInfo {
            width: 100%;
            font-size: 14px;
            color: #999;

            .teacherResearch {
              width: 100%;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }

        &:hover {
          border: none;
          -webkit-transition: all 0.3s ease 0s;
          transition: all 0.3s ease 0s;
          //border: 1px solid #ffffff;
          cursor: pointer;
          -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
          box-shadow: 0 5px 10px 1px #d2e6ff;
        }
      }

      .talentSmallBox:nth-child(4n) {
        margin-right: 0;
      }
    }

    .pagination {
      text-align: center;
      margin-bottom: 20px;
    }
  }
}
</style>
